
    import React from 'react';
    import { usePostReportingSuspend,usePostReportingCreate, usePostReportingSoftDelete,usePostReportingMultipleSoftDelete, usePostReportingUpdate,useApprovePostReportingKYC,useUpdateKYCDocument  } from '../../queries/PostReporting.queries';
    import PostReporting from './PostReporting';
    
    const PostReportingContainer = () => {
    
      const {mutate:addRecord} = usePostReportingCreate();
      const {mutate:editRecord} = usePostReportingUpdate();
      const {mutate:deleteRecord} = usePostReportingSoftDelete();
      const {mutate:deleteRecords} = usePostReportingMultipleSoftDelete();
      const {mutate:reportedPostSuspend} = usePostReportingSuspend();
      const {mutate:approveKYC} = useApprovePostReportingKYC();
      const {mutate:verifyKYCDocumentUpload} = useUpdateKYCDocument();
    
      const onAddRecord = (record) => {
        return new Promise((resolve,reject) => {
          addRecord(record, {
            onSuccess: async () => resolve('Record created successfully.'),
            onError: async (error) => reject(error?.message),
          });
        })
      };
    
      const onEditRecord = (record) => {
        return new Promise((resolve, reject) => {
          editRecord(
            record,
            {
              onSuccess: async () => resolve('Record updated successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };
    
      const onDeleteRecord = (record) => {
        return new Promise((resolve, reject) => {
          deleteRecord(
            record, 
            {
              onSuccess: async () => resolve('Record deleted successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };

      const onMultiDelete = (record) => {
        return new Promise((resolve, reject) => {
          deleteRecords(
            record, 
            {
              onSuccess: async () => resolve('Records deleted successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };
      const onPostReportingSuspend = (record) => {
        return new Promise((resolve, reject) => {
          record.isBlocked = true
          reportedPostSuspend(
            record,
            {
              onSuccess: async () => resolve('Record updated successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };
      const onApproveKYC = (record) => {
        return new Promise((resolve, reject) => {
          approveKYC(
            record, 
            {
              onSuccess: async () => resolve('Records deleted successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };

      const onKYCDocumentUpload = (record) => {
        return new Promise((resolve, reject) => {
          console.log("sgr")
          verifyKYCDocumentUpload(
            record, 
            {
              onSuccess: async () => resolve('Records deleted successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };

      return (
        <PostReporting 
          addRecord={onAddRecord}
          deleteRecord={onDeleteRecord}
          deleteRecords={onMultiDelete}
          editRecord={onEditRecord}
          reportedPostSuspend={onPostReportingSuspend}
          approveKYC={onApproveKYC}
          verifyKYCDocumentUpload ={onKYCDocumentUpload}
        />
      )
    }
    
    export default PostReportingContainer;
    